import React from 'react';

interface MessageOuterWrapperProps {
  messageRole: 'user' | 'agent' | 'tool' | 'system';
  inMiniMode?: boolean;
  agent?: any;
  colorVariants?: any;
  isSharedUserMessage?: boolean;
  discussingObject?: string;
  children: React.ReactNode;
}

const MessageOuterWrapper: React.FC<MessageOuterWrapperProps> = ({
  messageRole,
  inMiniMode = false,
  agent,
  colorVariants,
  isSharedUserMessage = false,
  discussingObject,
  children,
}) => {
  const wrapperClass = `message-outer-wrapper ${
    messageRole === 'agent'
      ? 'agent-outer-message'
      : messageRole === 'user'
        ? isSharedUserMessage
          ? 'user-outer-message shared-user-outer-message'
          : 'user-outer-message'
        : messageRole === 'system'
          ? 'system-outer-message'
          : 'tool-outer-message'
  }`;

  return (
    <div className={wrapperClass}>
      {messageRole === 'agent' &&
        inMiniMode &&
        discussingObject !== 'fast-chat' && (
          <div className='agent-dreamie-icon-wrapper'>
            <div
              className='agent-dreamie-icon'
              style={
                colorVariants
                  ? {
                      backgroundColor: colorVariants.darker,
                    }
                  : {}
              }
            >
              <img src={agent?.image_url} />
            </div>
          </div>
        )}
      {children}
    </div>
  );
};

export default MessageOuterWrapper;
